import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ClientsList.css";
import Sidebar from "./sidebar";
import SearchIcon from "@mui/icons-material/Search";

const ClientsList = () => {
  const [clients, setClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const clientsPerPage = 15;
  const navigate = useNavigate();

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}v1/clients`, {
        headers: {
          "x-api-key": "12345xxa",
        },
      })
      .then((res) => {
        setClients(res.data);
        setFilteredClients(res.data);
      })
      .catch((error) => {
        console.error("Ошибка при получении данных о клиентах:", error);
      });
  };

  useEffect(() => {
    const filtered = clients.filter((client) => {
      const query = searchQuery.toLowerCase();
      return (
        client.name.toLowerCase().includes(query) ||
        client.bin.toLowerCase().includes(query) ||
        client.address.toLowerCase().includes(query)
      );
    });
    setFilteredClients(filtered);
    setCurrentPage(1);
  }, [searchQuery, clients]);

  const handleAddClient = () => {
    navigate("/ClientsList/AddClientModal");
  };

  const handleRowClick = (clientId) => {
    navigate(`/ClientsList/ClientDetails/${clientId}`);
  };

  const handleSelectClient = (clientId) => {
    setSelectedClients((prevSelected) =>
      prevSelected.includes(clientId)
        ? prevSelected.filter((id) => id !== clientId)
        : [...prevSelected, clientId]
    );
  };

  const handleDeleteClients = () => {
    const requests = selectedClients.map((id) =>
      axios.delete(`${process.env.REACT_APP_API_URL}v1/clients/${id}`, {
        headers: {
          "x-api-key": "12345xxa",
        },
      })
    );

    Promise.all(requests)
      .then(() => {
        setClients((prev) => prev.filter((client) => !selectedClients.includes(client.id)));
        setFilteredClients((prev) => prev.filter((client) => !selectedClients.includes(client.id)));
        setSelectedClients([]);
      })
      .catch((error) => {
        console.error("Ошибка при удалении клиентов:", error);
      });
  };

  const handleSyncClients = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}v1/sync`, null, {
        headers: {
          'x-api-key': '12345xxa',
        },
      });
      console.log("✅ Клиенты успешно синхронизированы:", response.data);
      alert("Клиенты успешно синхронизированы!");

      // Перезапросим список
      fetchClients();
    } catch (error) {
      console.error("❌ Ошибка при синхронизации клиентов:", error);
      alert("Ошибка при синхронизации клиентов. Подробнее в консоли.");
    }
  };

  const indexOfLastClient = currentPage * clientsPerPage;
  const indexOfFirstClient = indexOfLastClient - clientsPerPage;
  const currentClients = filteredClients.slice(indexOfFirstClient, indexOfLastClient);
  const totalPages = Math.ceil(filteredClients.length / clientsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="clients-list-page">
      <div className="sidebar-container">
        <Sidebar />
      </div>
      <div className="main-content-crm">
        <div className="clients-list-header">
          <div className="search-bar-new">
            <div className="search-section">
              <h2 className="clients-title">📋 Список клиентов</h2>
              <div className="search-wrapper">
                <SearchIcon className="search-icon" />
                <input
                  type="text"
                  placeholder="Поиск по наименованию, БИН или адресу"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="clients-list-input"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="clients-table-wrapper">
          <table className="clients-table">
            <thead>
              <tr>
                <th>✔</th>
                <th>Наименование</th>
                <th>БИН</th>
                <th>Телефон</th>
                <th>Адрес</th>
                <th>E-Mail</th>
              </tr>
            </thead>
            <tbody>
              {currentClients.map((client) => (
                <tr key={client.id} className="client-row">
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedClients.includes(client.id)}
                      onChange={() => handleSelectClient(client.id)}
                    />
                  </td>
                  <td onClick={() => handleRowClick(client.id)}>{client.name}</td>
                  <td onClick={() => handleRowClick(client.id)}>{client.bin}</td>
                  <td onClick={() => handleRowClick(client.id)}>{client.phone}</td>
                  <td onClick={() => handleRowClick(client.id)}>{client.address}</td>
                  <td onClick={() => handleRowClick(client.id)}>{client.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => paginate(i + 1)}
              className={`pagination-button ${currentPage === i + 1 ? "active" : ""}`}
            >
              {i + 1}
            </button>
          ))}
        </div>

        <div className="clients-buttons">
          <button className="add-client-btn" onClick={handleAddClient}>
            ➕ Добавить клиента
          </button>
          <button
            className="delete-client-btn"
            onClick={handleDeleteClients}
            disabled={selectedClients.length === 0}
          >
            🗑 Удалить выбранных
          </button>
          <button
            className="sync-client-btn"
            onClick={handleSyncClients}
          >
            🔄 Синхронизировать клиентов
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientsList;
